import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { AccessRequestNodes } from '../../fragments/generated/AccessRequestNodes';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAccessRequestsQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  page: Types.PageInput;
}>;


export type GetAccessRequestsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, accessRequests?: { __typename?: 'AccessRequestConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes: Array<{ __typename?: 'AccessRequest', id?: string | null, requestedAt?: string | null, hasAccountUser?: boolean | null, hasMemberLicense?: boolean | null, requestedResource?: { __typename?: 'Collection', id: string, name: string, collectionProject: { __typename?: 'Project', id: string, name: string } } | { __typename?: 'FileAsset', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null } | { __typename?: 'FolderAsset', id: string, name: string, folderAssetProject?: { __typename?: 'Project', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null } | { __typename?: 'Project', id: string, name: string } | { __typename?: 'VersionStackAsset', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null } | null, requesterUser?: { __typename?: 'UserInfo', id: string, email: string, name?: string | null, profileImageUrl?: string | null, avatarColor?: Types.AvatarColor | null } | null }> } | null } | null };


export const GetAccessRequests = /*#__PURE__*/ gql`
    query GetAccessRequests($accountId: ID!, $page: PageInput!) {
  account(accountId: $accountId) {
    id
    accessRequests(page: $page) {
      ...AccessRequestNodes
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    ${AccessRequestNodes}` as unknown as DocumentNode<GetAccessRequestsQuery, GetAccessRequestsQueryVariables>;

          

          export const useGetAccessRequestsQuery = (options?:QueryHookOptions<GetAccessRequestsQuery, GetAccessRequestsQueryVariables>) => useQuery(GetAccessRequests, options);

          

          export type GetAccessRequestsQueryOptions = QueryHookOptions<GetAccessRequestsQuery, GetAccessRequestsQueryVariables>;

          

          export const useGetAccessRequestsLazyQuery = (options?:LazyQueryHookOptions<GetAccessRequestsQuery, GetAccessRequestsQueryVariables>) => useLazyQuery(GetAccessRequests, options);

          

          export type GetAccessRequestsQueryResult = ReturnType<typeof useGetAccessRequestsQuery>;

          
